import { EstimatedDeliveryDateWebRenderer } from "./web";
import { EstimatedDeliveryDateBlockProps } from "./types";

export function EstimatedDeliveryDateWebEditor(
  props: EstimatedDeliveryDateBlockProps,
) {
  return <EstimatedDeliveryDateWebRenderer {...props} />;
}
